<template>
  <Authenticate>
    <VuelidateLogin />
  </Authenticate>
</template>

<script>
import Authenticate from "@/components/authenticate/Authenticate";
import VuelidateLogin from "@/components/authenticate/VuelidateLogin";

export default {
  components: {
    Authenticate,
    VuelidateLogin
  }
};
</script>
